import React from 'react';
import { Spinner } from 'baseui/spinner';
import { Lead } from '../../backend/lead';
import { StyledEventBody } from './styled-components';
import useGetUser from '../../hooks/useGetUserById';
import useGetProperty from '../properties/hooks/useGetProperty';

const AssignedLead = (props: Lead & { actionBy: string | undefined }) => {
  const { assignedProperty, tenantName, actionBy } = props;

  const propertyRef = assignedProperty?.propertyRef;

  const propertyQuery = useGetProperty(propertyRef);

  const property = propertyQuery.data;

  const userQuery = useGetUser(actionBy);

  const actionByUser = userQuery.data;

  if (propertyQuery.isLoading || userQuery.isLoading) {
    return <Spinner $size="small" />;
  }

  return (
    <>
      <StyledEventBody>
        {actionByUser?.name} assigned you {tenantName || 'a lead'}
        {property?.name ? ` for ${property.name}.` : '.'}
      </StyledEventBody>
    </>
  );
};

export default AssignedLead;
